<script>
import Cropper from "cropperjs";

export default {
    name: "AvatarCropper",
    model: {
        prop: "show",
        event: "change",
    },
    props: {
        show: Boolean,
        image: String,
        title: {
            type: String,
            default: '头像剪裁'
        },
        aspectRatio: {
            type: [String, Number],
            default() {
                return 1;
            }
        }
    },
    data() {
        return {
            cropperImageSrc: "",
            cropper: null,
            showCropperModal: false,
            base64Image: null,
            cropperDetail: {},
            spfzd: 1,
            czfzd: 1,
        }
    },
    watch: {
        show() {
            this.statusChange()
        },
        image() {
            this.cropperImageSrc = this.image
        }
    },
    mounted() {
        this.showCropperModal = this.show
        this.cropperImageSrc = this.image
        this.initCropper()
    },
    methods: {
        statusChange() {
            this.cropperImageSrc = this.image
            this.showCropperModal = this.show
            
            if (this.showCropperModal) {
                setTimeout(() => {
                    this.initCropper()
                }, 100);
            }
        },
        rotateLeft() {
            if (!this.cropper) return;
            
            this.cropper.rotate(-90)
        },
        cancelImage() {
            this.closeModal()
            
            if (!this.cropper) return;
            
            setTimeout(() => {
                this.cropper.destroy()
                this.cropper = null
            }, 10)
        },
        croppedImage() {
            if (!this.cropper) return;
            
            let data = this.cropper.getCroppedCanvas({
                maxWidth: 1500,
                maxHeight: 1500,
            }).toDataURL();
            
            this.$emit('cropped', data)
            
            setTimeout(() => {
                this.cropper.destroy()
            }, 100)
            
            this.closeModal()
        },
        closeModal() {
            this.cropperImageSrc = null;
            
            this.$emit('change', false)
        },
        rotateRight() {
            if (!this.cropper) return;
            
            this.cropper.rotate(90)
        },
        initCropper() {
            if (this.cropper) this.cropper.destroy()
            
            if (!this.cropperImageSrc) return;
            
            setTimeout(() => {
                let el = document.getElementById('cropperImage');
                let preview = document.getElementById('cropperImagePreview')
                
                this.cropper = new Cropper(el, {
                    aspectRatio: this.aspectRatio,
                    preview,
                    dragMode: "move",
                    crop: (event) => {
                        this.cropperDetail = event.detail
                    },
                })
            }, 50)
        },
        fd() {
            if (!this.cropper) return;
            
            this.cropper.scale(
                this.cropperDetail.scaleX * 1.1,
                this.cropperDetail.scaleY * 1.1,
            )
        },
        sx() {
            if (!this.cropper) return;
            
            this.cropper.scale(
                this.cropperDetail.scaleX * 0.9,
                this.cropperDetail.scaleY * 0.9,
            )
        },
        spfz() {
            if (!this.cropper) return;
            
            this.spfzd = this.spfzd === -1 ? 1 : -1;
            
            this.cropper.scale(this.spfzd, this.czfzd)
        },
        czfz() {
            if (!this.cropper) return;
            
            this.czfzd = this.czfzd === -1 ? 1 : -1;
            
            this.cropper.scale(this.spfzd, this.czfzd)
        },
    }
}
</script>

<template>
    <div>
        <a-modal width="800px" :title="title" :maskClosable="false" v-model="showCropperModal" footer="">
            <div class="avatar-cropper-container">
                <!-- 左侧裁剪区域 -->
                <div class="left-panel">
                    <div class="cropper-img-container bg-gz" v-if="cropperImageSrc">
                        <img id="cropperImage" :src="cropperImageSrc" alt="">
                    </div>
                    <div class="cropper-actions">
                        <a-button-group>
                            <a-button @click="fd" type="primary">放大</a-button>
                            <a-button @click="sx" type="primary">缩小</a-button>
                            <a-button @click="spfz" type="primary">水平翻转</a-button>
                            <a-button @click="czfz" type="primary">垂直翻转</a-button>
                            <a-button @click="rotateLeft" type="primary">向左旋转</a-button>
                            <a-button @click="rotateRight" type="primary">向右旋转</a-button>
                        </a-button-group>
                    </div>
                </div>
                
                <!-- 右侧预览和操作区域 -->
                <div class="right-panel">
                    <div class="preview-section">
                        <h3 class="preview-title">预览</h3>
                        <div id="cropperImagePreview" class="preview-box"></div>
                    </div>
                    <div class="action-buttons">
                        <a-button @click="cancelImage" style="margin-right: 10px;">取消</a-button>
                        <a-button type="primary" @click="croppedImage">确定</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<style scoped lang="less">
.avatar-cropper-container {
    display: flex;
    flex-direction: row;
    height: 500px;
    overflow: hidden;
}

.left-panel {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    overflow: hidden;
}

.cropper-img-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
    border: 1px solid #e8e8e8;
    overflow: hidden;
    position: relative;
}

#cropperImage {
    max-width: none;
    max-height: 100%;
    width: auto;
    height: 100%;
    object-fit: contain;
}

.cropper-actions {
    margin-top: 15px;
    display: flex;
    justify-content: center;
}

.right-panel {
    width: 250px;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #e8e8e8;
    padding-left: 20px;
}

.preview-section {
    flex: 1;
}

.preview-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
    text-align: center;
}

.preview-box {
    width: 200px;
    height: 200px;
    overflow: hidden;
    background: white;
    border: 2px solid #dddddd;
    margin: 0 auto 20px;
    border-radius: 50%;
}

.action-buttons {
    margin-top: auto;
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
}

.action-buttons /deep/ button {
    min-width: 80px;
}
</style>